import React, { useEffect, useRef, useState } from 'react'
import { Tab } from 'semantic-ui-react'
import * as XTerm from 'xterm'
import * as Base64ArrayBuffer from 'base64-arraybuffer'
import { useElement } from '../hooks/element'
import { useEventStream } from '../hooks/eventStream'
import { useServerConnection } from '../hooks/ServerConnection'
import { useGitlabAccessToken } from '../hooks/GitlabAccessToken'

type XtermInstancesRef = React.MutableRefObject<{
    [machineId: string]: XTerm.Terminal;
}>

const MachineLog = ({ xtermInstancesRef, machineId, allLogs }: { xtermInstancesRef: XtermInstancesRef, machineId: string, allLogs: {
    [machineId: string]: LogEntry[],
} }) => {
    const [terminalElement, terminalElementCallback] = useElement()
    const xtermRef = useRef<XTerm.Terminal>(null)

    useEffect(() => {
        if(terminalElement && xtermRef.current === null) {
            console.log(terminalElement)
            const terminal = new XTerm.Terminal({
                convertEol: true,
            })
            terminal.open(terminalElement)
            xtermRef.current = terminal
            xtermInstancesRef.current[machineId] = terminal

            for(const logEntry of allLogs[machineId]) {
                terminal.write(new Uint8Array(Base64ArrayBuffer.decode(logEntry.base64)))
            }
        }
    }, [terminalElement])

    useEffect(() => {
        if(xtermRef.current !== null) {
            xtermRef.current.clear()
            for(const logEntry of allLogs[machineId]) {
                xtermRef.current.write(new Uint8Array(Base64ArrayBuffer.decode(logEntry.base64)))
            }
            xtermRef.current.scrollToBottom()
        }
    }, [machineId])

    return (
        <div>
            <div ref={terminalElementCallback}/>
        </div>
    )
}

type LogEntry = {
    type: "stdout" | "stderr",
    base64: string,
}

const VMBuildingLogs = () => {
    const serverConnection = useServerConnection()
    const [accessToken] = useGitlabAccessToken()



    const [logs, setLogs] = useState<{
        [machineId: string]: LogEntry[],
    }>({})
    const xtermInstancesRef = useRef<{
        [machineId: string]: XTerm.Terminal,
    }>({})

    useEventStream(() => serverConnection.machineBuldingLogsStreams(accessToken), (update) => {
        if(update.type === "update") {
            if(xtermInstancesRef.current[update.machineId]) {
                xtermInstancesRef.current[update.machineId].write(new Uint8Array(Base64ArrayBuffer.decode(update.entry.base64)))
            }
            
            setLogs((oldLogs) => {
                return {
                    ...oldLogs,
                    [update.machineId]: [
                        ...oldLogs[update.machineId],
                        update.entry,
                    ],
                }
            })
        } else if(update.type === "init") {
            if(xtermInstancesRef.current[update.machineId]) {
                xtermInstancesRef.current[update.machineId].clear()
                for(const entry of update.entry) {
                    xtermInstancesRef.current[update.machineId].write(new Uint8Array(Base64ArrayBuffer.decode(entry.base64)))
                }
            }
            
            setLogs((oldLogs) => {
                return {
                    ...oldLogs,
                    [update.machineId]: update.entry,
                }
            })
        } else if(update.type === "close") {
            setLogs((oldLogs) => {
                const { [update.machineId]: _, ...rest } = oldLogs

                return rest
            })
        }
    }, [serverConnection, accessToken, xtermInstancesRef])

    return (
        <>
            {
                Object.keys(logs).length > 0 && (
                    <Tab
                        panes={
                            Object.keys(logs).map((machineId) => {
                                return {
                                    menuItem: machineId,
                                    render: () => (
                                        <div>
                                            <MachineLog
                                                xtermInstancesRef={xtermInstancesRef}
                                                machineId={machineId}
                                                allLogs={logs}
                                            />
                                        </div>
                                    )
                                }
                            })
                        }
                    />
                )
            }
        </>
    )
}

export default VMBuildingLogs
